import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { adresaProjekta } from '../lib/supabase'

/** Prijava e-poštom i lozinkom. Javne registracije nema (C25) — nalog nastaje samo kroz
 *  pozivnicu, pa ovaj ekran nema „napravi nalog". */
export function Prijava() {
  const [email, postaviEmail] = useState('')
  const [lozinka, postaviLozinku] = useState('')
  const [greska, postaviGresku] = useState<string | null>(null)
  const [uToku, postaviUToku] = useState(false)

  async function posalji(dogadjaj: React.FormEvent) {
    dogadjaj.preventDefault()
    postaviGresku(null)
    postaviUToku(true)
    const { error } = await supabase.auth.signInWithPassword({ email, password: lozinka })
    postaviUToku(false)
    if (error) {
      // Poruka je namjerno ista za pogrešnu lozinku i nepostojeći nalog.
      postaviGresku('Pogrešna e-pošta ili lozinka.')
    }
  }

  const mozeDalje = email.trim() !== '' && lozinka !== '' && !uToku

  return (
    <div className="prijava">
      <form className="prijava__list" onSubmit={posalji} data-testid="prijava-forma">
        <div className="prijava__zaglavlje">
          <h1 className="marka">bookbee</h1>
          <div className="prijava__podnaslov broj" data-testid="prijava-projekat">
            {adresaProjekta}
          </div>
        </div>

        {greska && (
          <div className="greska" role="alert" data-testid="prijava-greska">
            {greska}
          </div>
        )}

        <div className="prijava__red">
          <label className="oznaka polje-oznaka" htmlFor="polje-email">
            E-pošta
          </label>
          <input
            id="polje-email"
            className="polje"
            type="email"
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            value={email}
            onChange={(e) => postaviEmail(e.target.value)}
            data-testid="polje-email"
          />
        </div>

        <div className="prijava__red">
          <label className="oznaka polje-oznaka" htmlFor="polje-lozinka">
            Lozinka
          </label>
          <input
            id="polje-lozinka"
            className="polje"
            type="password"
            autoComplete="current-password"
            value={lozinka}
            onChange={(e) => postaviLozinku(e.target.value)}
            data-testid="polje-lozinka"
          />
        </div>

        <div className="prijava__red">
          <button
            type="submit"
            className="dugme dugme--glavno"
            style={{ width: '100%' }}
            disabled={!mozeDalje}
            data-testid="dugme-prijava"
          >
            {uToku ? 'Prijava…' : 'Prijavi se'}
          </button>
          {!mozeDalje && !uToku && (
            <div className="razlog" data-testid="prijava-razlog">
              Unesi e-poštu i lozinku.
            </div>
          )}
        </div>
      </form>
    </div>
  )
}
